import PropTypes from 'prop-types'
import React, { useState, useRef, useEffect } from 'react'
import { CTabContent, CTabPane } from '@coreui/react'
import CIcon from '@coreui/icons-react'

import {
  CCard,
  CCardBody,
  CCardImage,
  CCardText,
  CCol,
  CRow,
  CTable,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CModal,
  CModalBody,
  CButton,
} from '@coreui/react'

import {
  cilCompress,
  cilCloudDownload,
} from '@coreui/icons'

const DocsExample = (props) => {
  const { children, href, tabContentClassName, data } = props
  const [visible, setVisible] = useState(false)
  const [zoom, setZoom] = useState(1);
  const [translate, setTranslate] = useState({ x: 0, y: 0 })
  const [isPanning, setIsPanning] = useState(false)
  const [startPan, setStartPan] = useState({ x: 0, y: 0 })
  const imgRef = useRef(null)
  const containerRef = useRef(null)

  const zoomIn = () => setZoom((z) => Math.min(z + 0.25, 3));
  const zoomOut = () => setZoom((z) => Math.max(z - 0.25, 0.5));
  const resetZoom = () => { setZoom(1); setTranslate({ x: 0, y: 0 }); }

  useEffect(() => {
    if (containerRef.current) containerRef.current.style.cursor = zoom > 1 ? 'grab' : 'default'
  }, [zoom])

  const clampTranslate = (x, y) => {
    const c = containerRef.current
    const img = imgRef.current
    if (!c || !img) return { x, y }
    const containerW = c.clientWidth
    const containerH = c.clientHeight
    const imgW = img.clientWidth // clientWidth ignores CSS transform scale
    const imgH = img.clientHeight
    const scaledW = imgW * zoom
    const scaledH = imgH * zoom

    let maxX = 0
    let maxY = 0
    if (scaledW > containerW) {
      maxX = (scaledW - containerW) / 2
    }
    if (scaledH > containerH) {
      maxY = (scaledH - containerH) / 2
    }

    const clampedX = Math.max(-maxX, Math.min(maxX, x))
    const clampedY = Math.max(-maxY, Math.min(maxY, y))
    return { x: clampedX, y: clampedY }
  }

  useEffect(() => {
    // Global listeners while panning so drag continues outside the container
    const onMouseMove = (e) => {
      if (!isPanning) return
      e.preventDefault()
      const desired = { x: e.clientX - startPan.x, y: e.clientY - startPan.y }
      const clamped = clampTranslate(desired.x, desired.y)
      setTranslate(clamped)
    }
    const onMouseUp = () => {
      if (!isPanning) return
      setIsPanning(false)
      if (containerRef.current) containerRef.current.style.cursor = 'grab'
    }
    const onTouchMove = (e) => {
      if (!isPanning) return
      e.preventDefault()
      const t = e.touches[0]
      const desired = { x: t.clientX - startPan.x, y: t.clientY - startPan.y }
      const clamped = clampTranslate(desired.x, desired.y)
      setTranslate(clamped)
    }
    const onTouchEnd = () => setIsPanning(false)

    if (isPanning) {
      document.addEventListener('mousemove', onMouseMove)
      document.addEventListener('mouseup', onMouseUp)
      document.addEventListener('touchmove', onTouchMove, { passive: false })
      document.addEventListener('touchend', onTouchEnd)
    }
    return () => {
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
      document.removeEventListener('touchmove', onTouchMove)
      document.removeEventListener('touchend', onTouchEnd)
    }
  }, [isPanning, startPan])


  // Función para obtener datos del servidor
  function truncateText(text, maxLength, truncationText = "...") {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + truncationText;
    }
    return text;
  }

  // Función para descargar la imagen
  const handleDownload = (imageUrl) => {
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = 'imagen_descargada.jpg'; // Puedes cambiar el nombre del archivo aquí
    link.click();
  };

  return (
    <>
      <div className="example">
        <CTabContent className={`rounded-bottom ${tabContentClassName ? tabContentClassName : ''}`}>
          <CTabPane className="preview" visible>
            <CCard style={{ width: '100%', height: '18.8rem' }}>
              <div style={{ position: 'relative' }}>
                <CCardImage orientation="top" src={data && data.length > 0 && data[0].url_frame ? data[0].url_frame : "https://3fpy.deepgaze.xyz/images/casita.jpg"} width="800" height="150" />
                <button className='button-modal-frame' style={{ position: 'absolute', bottom: '10px', right: '40px' }}>
                  <CIcon icon={cilCloudDownload} title="Download file" style={{ '--ci-primary-color': 'white' }} 
                  onClick={() => handleDownload(data && data.length > 0 && data[0].url_frame ? data[0].url_frame : "https://3fpy.deepgaze.xyz/images/casita.jpg")}/>
                </button>
                <button className='button-modal-frame' style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
                  <CIcon icon={cilCompress} style={{ '--ci-primary-color': 'white' }} onClick={() => setVisible(!visible)} />
                </button>
              </div>

              <CCardBody>
                <CCardText className='text-card-frame' width="800" height="140">
                  <CRow>
                    <CCol xs='12'>
                      <CTable borderless className='margin-bottom-table'>
                        <CTableBody>
                          <CTableRow>
                            <CTableDataCell className="quitar-padding letra-titulo-2">
                              <strong>Video:</strong>
                            </CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableDataCell className="quitar-padding letra-contenido">
                              {data && data.length > 0 && data[0].name_video ?
                                <div
                                  className="truncate-text"
                                  title={truncateText(data[0].name_video, 30) === data[0].name_video ? '' : data[0].name_video}
                                >
                                  {/* Si se trunca, muestra el tooltip con el nombre completo */}
                                  {truncateText(data[0].name_video, 30)}
                                </div>
                                : "Video_segmento1.avi"}
                            </CTableDataCell>
                          </CTableRow>
                        </CTableBody>
                      </CTable>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol xs='12'>
                      <CTable borderless className='margin-bottom-table'>
                        <CTableBody>
                          <CTableRow>
                            <CTableDataCell className="quitar-padding-with letra-titulo-2">
                              <strong>Tipo de cámara:</strong>
                            </CTableDataCell>
                            <CTableDataCell className="quitar-padding letra-titulo-2">
                              <strong>Frame:</strong>
                            </CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableDataCell className="quitar-padding letra-contenido">
                              {data && data.length > 0 && data[0].tipo_camara ? data[0].tipo_camara : "Frontal"}
                            </CTableDataCell>
                            <CTableDataCell className="quitar-padding letra-contenido">
                              {data && data.length > 0 && data[0].id_frame ? data[0].id_frame : "03:35"}
                            </CTableDataCell>
                          </CTableRow>
                        </CTableBody>
                      </CTable>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol xs='12'>
                      <CTable borderless className='margin-bottom-table'>
                        <CTableBody>
                          <CTableRow>
                            <CTableDataCell className="quitar-padding letra-titulo-2">
                              <strong>Tipo de detección:</strong>
                            </CTableDataCell>
                          </CTableRow>
                          <CTableRow>
                            <CTableDataCell className="quitar-padding letra-contenido">
                              {data && data.length > 0 && data[0].tipo ? data[0].tipo_especifico : "Señaletica de tránsito"}
                            </CTableDataCell>
                          </CTableRow>
                        </CTableBody>
                      </CTable>
                    </CCol>
                  </CRow>
                </CCardText>
              </CCardBody>
            </CCard>
          </CTabPane>
        </CTabContent>
      </div>
      <CModal
        className=''
        alignment="center"
        visible={visible}
        onClose={() => setVisible(false)}
        aria-labelledby="VerticallyCenteredExample"
        size="lg"
      >
        <CModalBody className=''>
          <CCard style={{ width: '48rem', height: '30 rem' }}>
            <div style={{ position: 'relative' }}>
              <div
                ref={containerRef}
                onMouseDown={(e) => {
                  if (zoom <= 1) return
                  e.preventDefault()
                  setIsPanning(true)
                  setStartPan({ x: e.clientX - translate.x, y: e.clientY - translate.y })
                  if (containerRef.current) containerRef.current.style.cursor = 'grabbing'
                }}
                onMouseLeave={() => { if (isPanning) setIsPanning(false) }}
                onTouchStart={(e) => {
                  if (zoom <= 1) return
                  const t = e.touches[0]
                  setIsPanning(true)
                  setStartPan({ x: t.clientX - translate.x, y: t.clientY - translate.y })
                }}
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', width: '100%', touchAction: 'none' }}>
                <img
                  ref={imgRef}
                  src={data && data.length > 0 && data[0].url_frame ? data[0].url_frame : "https://3fpy.deepgaze.xyz/images/casita.jpg"}
                  alt="frame"
                  style={{
                    width: '100%',
                    maxWidth: '1000px',
                    height: 'auto',
                    transform: `translate(${translate.x}px, ${translate.y}px) scale(${zoom})`,
                    transition: isPanning ? 'none' : 'transform 150ms ease-in-out',
                    display: 'block',
                    cursor: zoom > 1 ? (isPanning ? 'grabbing' : 'grab') : 'default'
                  }}
                />
              </div>
              <div style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', gap: '8px' }}>
                {/* <CButton size="sm" color="light" onClick={zoomOut} title="Zoom out">-</CButton> */}
                <CButton size="sm" color="light" onClick={resetZoom} title="Reset zoom">1x</CButton>
                <CButton size="sm" color="light" onClick={zoomIn} title="Zoom in">+</CButton>
              </div>
              <button className='button-modal-frame' style={{ position: 'absolute', bottom: '10px', right: '40px' }}>
                <CIcon icon={cilCloudDownload} title="Download file" style={{ '--ci-primary-color': 'white' }} 
                onClick={() => handleDownload(data && data.length > 0 && data[0].url_frame ? data[0].url_frame : "https://3fpy.deepgaze.xyz/images/casita.jpg")} />
              </button>
              <button className='button-modal-frame' style={{ position: 'absolute', bottom: '10px', right: '10px' }}>
                <CIcon icon={cilCompress} style={{ '--ci-primary-color': 'white' }} onClick={() => setVisible(!visible)} />
              </button>
            </div>

          </CCard>
        </CModalBody>

      </CModal>
    </>
  )
}

DocsExample.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  tabContentClassName: PropTypes.string,
  data: PropTypes.array // Agrega esta línea para definir la prop data
}

export default React.memo(DocsExample)